
import React, { createContext, useContext, useState } from "react";


const SessionValidationContext = createContext({});
export const SessionValidationProvider = ({ children }) => {
  const [sessionExpired, setSessionExpired] = useState(false);



  return (
    <SessionValidationContext.Provider
      value={{
        sessionExpired,
        setSessionExpired,
      }}
    >
      {children}
    </SessionValidationContext.Provider>
  );
};

export default function SessionValidation() {
  return useContext(SessionValidationContext);
}
